<template>
    <div>
        <div v-if="treeList.subheader && hasCanLinks(treeList.children)">
            <v-subheader class="mt-3 grey--text text--darken-1">
                <span> {{ $t(treeList.subheader) }} </span>
                <v-icon small class="ml-1">
                    {{ treeList.icon }}
                </v-icon>
            </v-subheader>
            <v-flex v-if="treeList.children && hasCanLinks(treeList.children)">
                <item-tree v-for="(childTree, n) in treeList.children" :key="n" :tree="childTree" />
            </v-flex>
        </div>
        <v-list v-else-if="treeList.url && hasCanLinks([treeList])" class="pa-0">
            <v-list-item :to="treeList.url" active-class="grey lighten-2">
                <v-list-item-icon>
                    <v-icon>{{ treeList.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title :class="`${$options.name}__OmitName`" v-text="$t(treeList.text)" />
            </v-list-item>
        </v-list>
        <v-list v-else-if="!treeList.url && hasCanLinks([treeList])" class="pa-0">
            <v-list-group v-model="treeList.active" :prepend-icon="treeList.icon">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title :class="`${$options.name}__OmitName`" v-text="$t(treeList.text)" />
                    </v-list-item-content>
                </template>
                <template v-for="(groupList, index) in treeList.children">
                    <v-layout :key="index">
                        <v-list-item
                            v-if="groupList.url && hasCanLinks([groupList])"
                            :key="groupList.text"
                            :to="groupList.url"
                            active-class="grey lighten-2"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ groupList.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title :class="`${$options.name}__OmitName`" v-text="$t(groupList.text)" />
                        </v-list-item>
                        <v-flex v-if="groupList.children && hasCanLinks(groupList.children)">
                            <item-tree v-for="(childTree, n) in groupList.children" :key="n" :tree="childTree" />
                        </v-flex>
                    </v-layout>
                </template>
            </v-list-group>
        </v-list>
    </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppContext } from '../../../store/context';

type NavigationBarType = AppContext.NavigationBar.Type;

@Component({
    name: 'ItemTree',
    components: {},
})
export default class ItemTree extends Vue {
    @Prop({ default: {} }) tree: NavigationBarType;

    get treeList(): NavigationBarType {
        return this.tree;
    }

    // 自分の権限で表示可能なナビゲーションリンクが配下にあるか判定する（難解な処理）
    hasCanLinks(children: Array<NavigationBarType> = []): boolean {
        const canLinks = children.filter(child => {
            // URLがないものはその時点でアクセス可能にならない
            if (!child.url) return false;
            // アクセス制限がされていないメニューの場合は権限あり判定
            if (!child.can) return true;

            // 権限があるか判定
            const canParams = child.can.split(' ');
            return !!(this as any).$can(canParams[0], canParams[1]);
        });

        // 権限があるURLが一つでもあれば表示可能とする
        if (canLinks.length > 0) {
            return true;
        } else {
            // ない場合はさらに子供をチェックする（再帰）
            const canLinks2 = children.filter(child => {
                return child.children ? this.hasCanLinks(child.children) : false;
            });
            return canLinks2.length > 0 ? true : false;
        }
    }
}
</script>

<style lang="scss" scoped>
.v-list-group__header__prepend-icon {
    font-size: 24px;
}
.ItemTree {
    &__OmitName {
        white-space: normal;
    }
}
</style>
